export default __webpack_public_path__ + "static/media/expired-icon.7ce48be2.png";